export var HELPER_TEXT_POSTFIX_TESTID = 'helperText';
export var LABEL_TEXT_POSTFIX_TESTID = 'labelText';
export var SELECT_SEARCH_INPUT_POSTFIX_TESTID = 'searchInput';
export var TOGGLE_OPEN_SELECT_BUTTON_POSTFIX_TESTID = 'toggleOpenSelectButton';
